module.exports = __webpack_public_path__ + "media/images/favicon-aa6d8cb9773e84e09bfa9ce8edcae86c.ico";